/*
*   File : empty-screen.js
*   Author : https://evoqins.com
*   Description :  Empty screen component
*   Integrations : NA
*   Version : 1.0.0
*/

import PrimaryButton from "../Buttons/primary-button";

function EmptyScreen(props) {
    return (
        <div className={`${props.type == 1 ? "col-8 col-sm-7 col-md-6 col-lg-5" : "col-8 col-sm-7 col-md-6 col-lg-8"} mx-auto d-flex flex-column justify-content-center align-items-center gap-4 mt-4`}>
            <img src={props.emptyScreenImage}
                alt="empty screen image"
                className="col-8 col-md-6 img-fluid"
                draggable="false" />
            <p className='col col-sm-10 col-md-8 text-center e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-22px mb-0'>
                {props.description}
            </p>
            {
                props.btnLabel &&
                <PrimaryButton name={props.btnLabel}
                    className="col-9"
                    onPress={props.onClick} />
            }
        </div>
    )
}

export default EmptyScreen;